import { Box, CircularProgress } from "@mui/material";

const Spinner = ({ fullScreen = false }) => {
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(2, 1, 1, 0.1)",
    backdropFilter: "blur(1px)", 
    zIndex: 2000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const containerStyle = fullScreen
    ? overlayStyle
    : {
        display: "flex",
        minHeight: "60vh",
        alignItems: "center",
        justifyContent: "center",
      };

  return (
    <Box sx={containerStyle}>
      <CircularProgress color="dark" />
    </Box>
  );
};

export default Spinner;
